import {
  ErrorHandler,
  Injectable,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { SharedModule } from './pages/shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { StoreModule } from '@ngrx/store';
import * as Sentry from '@sentry/browser';
import { environment } from '../environments/environment';
import { AppQueries } from './app.queries';
import { reducers } from './app.reducers';
import { AreaRestaurantsPageComponent } from './pages/area-restaurants/area-restaurants-page.component';
import { AgreementStatusesCommands } from './pages/shared/gui/agreement-statuses/agreement-statuses.commands';
import { AgreementStatusesComponent } from './pages/shared/gui/agreement-statuses/agreement-statuses.component';
import { AgreementStatusesQueries } from './pages/shared/gui/agreement-statuses/agreement-statuses.queries';

const ngRxProviders: ModuleWithProviders[] = [
  StoreModule.forRoot(reducers),
  StoreDevtoolsModule.instrument({
    maxAge: 25,
    logOnly: environment.production,
  }),
  StoreRouterConnectingModule.forRoot(),
];

// Sentry
Sentry.init({
  dsn: 'https://853f9539c5f44bf8bbb85f87b09d3d92@sentry.io/5182489',
  environment: environment.stage,
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: environment.stage !== 'development',
    }),
  ],
});
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error: any) {
    // 補足されなかったエラーを Sentry に報告する。
    Sentry.captureException(error.originalError || error);
    throw error;
  }
}

@NgModule({
  declarations: [AppComponent, AgreementStatusesComponent],
  imports: [
    ...ngRxProviders,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
  ],
  providers: [
    AgreementStatusesQueries,
    AgreementStatusesCommands,
    AppQueries,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
